import { Injectable } from '@angular/core';
import { Order, QueryConfig, QueryEntity } from '@datorama/akita';
import { NotificationStore, NotificationState } from './notification.store';
import { BehaviorSubject } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const NOTIFICATION_PAGE_LIMIT = 10;

@Injectable({ providedIn: 'root' })
@QueryConfig({
  sortBy: 'created_at',
  sortByOrder: Order.DESC
})
export class NotificationQuery extends QueryEntity<NotificationState> {
  private _listSubject = new BehaviorSubject(1);
  list$ = this._listSubject.asObservable().pipe(
    switchMap((currentPage: number) => this.selectAll({
      limitTo: currentPage * NOTIFICATION_PAGE_LIMIT
    }))
  );

  constructor(protected store: NotificationStore) {
    super(store);
  }

  loadToPage(page) {
    this._listSubject.next(page);
  }
}
